var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58113 19.1795C14.7551 16.4981 18.8721 14.7304 20.932 13.8764C26.8136 11.4379 28.0357 11.0143 28.8323 11.0001C29.0075 10.9972 29.3992 11.0405 29.6529 11.2457C29.8672 11.419 29.9262 11.6531 29.9544 11.8174C29.9826 11.9817 30.0177 12.356 29.9898 12.6485C29.6711 15.9866 28.2919 24.0874 27.5903 27.8262C27.2935 29.4082 26.7089 29.9387 26.143 29.9906C24.9131 30.1034 23.9792 29.1804 22.788 28.402C20.924 27.1841 19.8709 26.4259 18.0616 25.2374C15.9706 23.8638 17.3261 23.1089 18.5178 21.8752C18.8296 21.5523 24.2485 16.6391 24.3534 16.1934C24.3665 16.1377 24.3787 15.9299 24.2549 15.8202C24.131 15.7105 23.9483 15.748 23.8164 15.7779C23.6294 15.8201 20.6517 17.782 14.8831 21.6635C14.0379 22.2421 13.2723 22.524 12.5864 22.5092C11.8302 22.4929 10.3756 22.083 9.29422 21.7326C7.96791 21.3029 6.91378 21.0757 7.00557 20.3458C7.05338 19.9656 7.57857 19.5769 8.58113 19.1795Z",
    fill: "#29A9EB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.de43ab55d04eed54b74fe3e550f26f5a.svg";
export { ForwardRef as ReactComponent };